import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const PARTNER: AppRouteRecordRaw = {
  path: '/partner',
  name: 'partner',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: '运营商管理',
    icon: 'icon-user-group',
    requiresAuth: true,
    order: 6,
  },
  children: [
    {
      path: 'list',
      name: 'PartnerList',
      component: () => import('@/views/partner/index.vue'),
      meta: {
        locale: '运营商列表',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'station',
      name: 'PartnerStation',
      component: () => import('@/views/partner/station.vue'),
      meta: {
        locale: '运营商站点关联',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
    {
      path: 'deposit',
      name: 'PartnerDeposit',
      component: () => import('@/views/partner/deposit/index.vue'),
      meta: {
        locale: '客户预存',
        requiresAuth: true,
        roles: ['admin'],
      },
    },
  ],
};

export default PARTNER; 